/**
 * A confirmation that takes itself away.
 *
 * Success on this page is a green `Banner` for a few seconds rather than a line that stays
 * until something else happens. The page has four sections and every mutation refetches all
 * of them, so a note left standing is read as being about whatever the eye lands on next —
 * "an invitation has been sent" still on screen while somebody retires a car.
 *
 * Its own module because a hook exported beside a component trips
 * `react/only-export-components`, and both the page and the office section need it.
 */

import { useEffect, useState } from 'react';

/** How long a confirmation stays. Long enough to read twice, short enough to be about now. */
const SECONDS = 6;

export function useFadingNote(): [string | null, (next: string | null) => void] {
  const [note, setNote] = useState<string | null>(null);

  useEffect(() => {
    if (note === null) return;

    const timer = setTimeout(() => setNote(null), SECONDS * 1000);

    return () => clearTimeout(timer);
  }, [note]);

  return [note, setNote];
}
